<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Workflow Functional Approval Sequence
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="12">
          <b-input-group >
              <b-input-group-prepend><span class="p-2">Workflow Name</span></b-input-group-prepend>
              <b-form-select  v-model="tblData.wftypekey" :options="workflowtypes"  :plain="true" ></b-form-select>
              <b-input-group-prepend><span class="p-2">Requestor</span></b-input-group-prepend>
              <b-form-input v-model="tblData.requestor" @keyup.13.native="refresh()" placeholder="Requestor (% for wildcard)"></b-form-input>
              <b-input-group-prepend><span class="p-2">Approver</span></b-input-group-prepend>
              <b-form-input v-model="tblData.approver" @keyup.13.native="refresh()" placeholder="Approver (% for wildcard)"></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Workflow Functional Approval - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Workflow Name</label></b-input-group-prepend>
                      <b-form-select  v-model="frmdata.wftypekey" :options="workflowtypes" :state="!$v.frmdata.wftypekey.$error" :plain="true" ></b-form-select>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Requestor</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.requestor" placeholder="Requestor's Username " :state="!$v.frmdata.requestor.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Approver Sequence</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.approverSeq" placeholder="CSV of Approver's Username" :state="!$v.frmdata.approverSeq.$error"></b-form-input>
                </b-input-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import wfname from "../../apis/wffunctionalapproval";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        wftypekey: { required },
        requestor: { required },
        approverSeq: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{wftypekey: '', requestor:'', approverSeq:''},
      tblData: {
        page: 1,
        limit: 50,
        total: 0,
        sortBy: 'wftypekey',
        sortDesc: false
      },
      workflowtypes:[]
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
            thStyle: "width:30px",
          },
          {
            key: "wftypekey",
            label: "Job Type Name",
            sortable: true
          },
          {
            key: "requestor",
            label: "Requestor",
            thClass: "text-center",
            sortable: true
          },
          {
            key: "approverSeq",
            label: "Approval Sequence",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
    this.workflowtypes= await wfname.workflowtype();
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await wfname.list(this.tblData);      
      return list;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await wfname.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   

    search() {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.wftypekey= '';
        this.tblData.requestor= '';
        this.tblData.approver= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.functAppKey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await wfname.save(this.frmdata)
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await wfname.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
